import { COUNTRY_SUMMARY_ITEM } from '../../../SummaryList/SummaryItems/base';
import { NAME_PRE_SALT_POLYGON_SUMMARY_ITEM } from '../../../SummaryList/SummaryItems/presaltPolygoon';

export default [NAME_PRE_SALT_POLYGON_SUMMARY_ITEM, COUNTRY_SUMMARY_ITEM];
